import { useMemo } from 'react'
import { Choice } from '@cmsgov/design-system'
import { Card } from '@cmsgov/ds-medicare-gov'
import { zodResolver } from '@hookform/resolvers/zod'
import { Controller, FormProvider, useForm } from 'react-hook-form'
import { Trans, useTranslation } from 'react-i18next'
import Button from 'components/Button'
import { EasyPayStopFormData, createSchema } from './schema'
import { MySpinner } from 'components/MySpinner/MySpinner'
import { useEvent } from 'hooks/useEvent'

type EasyPayStopFormProps = {
  className?: string
  loading?: boolean
  onCancel: () => void
  onSubmit: (data: EasyPayStopFormData) => void
}
export function EasyPayStopForm ({
  className,
  loading,
  onCancel,
  onSubmit
}: EasyPayStopFormProps) {
  const { t } = useTranslation('easyPayStopPage', { keyPrefix: 'form' })

  const schema = useMemo(() => createSchema(t), [t])
  const methods = useForm({
    resolver: zodResolver(schema)
  })
  const { fireEvent } = useEvent('premiumsEasyPay')
  const { control, handleSubmit } = methods
  const { errors } = methods.formState

  return (
    // params in handlesubmit?
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(onSubmit)} className={className}>
        <h2 className="ds-text-heading--xl ds-u-margin-bottom--2">
          {t('heading')}
        </h2>
        <Card className="ds-u-padding--4">
          <Controller
            name="authorization"
            control={control}
            render={({ field }) => (
              <Choice
                type="checkbox"
                label={
                  <Trans
                    t={t}
                    i18nKey="authorization.label"
                    components={{
                      list: <ul className="ds-c-list" />,
                      li: <li />
                    }}
                  />
                }
                errorMessage={errors?.authorization?.message}
                {...field}
              />
            )}
          />
        </Card>
        <div className="ds-u-margin-y--3">{t('pleasePrint')}</div>
        <div className="ds-u-margin-top--3 ds-u-display--flex ds-u-flex-direction--column ds-u-md-flex-direction--row my-u-gap--12">
          <Button
            type="submit"
            className="ds-c-button ds-c-button--alternate ds-c-button--solid my-u-whitespace-nowrap"
            disabled={loading}
          >
            {loading && <MySpinner size="small" />} {t('buttons.submit')}
          </Button>

          {onCancel && (
            <Button
              type="button"
              onClick={(params) => {
                fireEvent(`premiums_easypaystop_cancel_click`, params)
                onCancel()
              }}
              className="ds-c-button my-u-whitespace-nowrap"
            >
              <span>{t('buttons.cancel')}</span>
            </Button>
          )}
        </div>
      </form>
    </FormProvider>
  )
}
